export const isStandalone = () => {
    return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone || // iOS support
        document.referrer.includes('android-app://')
    );
};

export const getAuthStorage = () => {
    // Using localStorage always for simplicity and session sharing across all tabs.
    return localStorage;
};

export const clearCache = async () => {
    if ('caches' in window) {
        try {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames.map(name => caches.delete(name))
            );
            console.log('🧹 Cache PWA limpo com sucesso (Login mantido).');
        } catch (e) {
            console.error('Erro ao limpar cache PWA:', e);
        }
    }
};
